import React from "react";
import "./LeftAndRightHeader.css";

interface LeftAndRightHeaderProps {
  badge?: React.ReactNode;
  badgeLabel?: string;
  leftTitle?: string;
  leftText?: string;
  rightText?: string;
}

export default function LeftAndRightHeader({
  badge,
  badgeLabel = "",
  leftTitle = "",
  leftText = "",
  rightText = "",
}: LeftAndRightHeaderProps) {
  return (
    <section className="left-right-header">
      <div className="header-badge">
        {badge && <span className="badge-icon">{badge}</span>}
        <span className="badge-label">{badgeLabel}</span>
      </div>

      <div className="content">
        <div className="left">
          <h2 dangerouslySetInnerHTML={{ __html: leftTitle }} />
          <p>{leftText}</p>
        </div>
        <div className="right">
          <p>{rightText}</p>
        </div>
      </div>
    </section>
  );
}
